import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { XmlEditorDebugger } from '../../code/xmlEditorDebugger';
import { AngularXmlEditorService } from '../../angular-xml-editor.service';
import { XmlEditorContext } from '../../code/xmlEditorContext.class';

@Component({
  selector: 'axed-debug',
  templateUrl: './xml-editor-debug.component.html',
  styleUrls: ['./xml-editor-debug.component.scss']
})
export class XmlEditorDebugComponent implements OnInit, OnDestroy {
  private editorContext: XmlEditorContext;

  @Input('editorContextId')
  set editorContextId(value: string) {
    if (!value) {
      return;
    }
    this.editorContext = this.editorService.getEditorContext(value);
    this.actualCursorPosChangedSubscription = this.editorContext.debugService.actualCursorPosChanged$.subscribe(pos => {
      this.cursorPosInfo = pos.StartPos.getDebugDescription();
    });
    this.inputSelectionSubscription = this.editorContext.debugService.inputSelectionChanged$.subscribe(info => {
      this.inputSelection = info;
    });
  }

  cursorPosInfo: string;
  inputSelection: string;

  private actualCursorPosChangedSubscription: Subscription;
  private inputSelectionSubscription: Subscription;

  constructor(private editorService: AngularXmlEditorService) {}

  ngOnInit() {}

  ngOnDestroy(): void {
    this.actualCursorPosChangedSubscription.unsubscribe();
    this.inputSelectionSubscription.unsubscribe();
  }
}
